/*
 * Module for Benefit Modification - Edit
 */
rs.module("content/participant/benefit/modification/edit",

    [
        "common/select-helper",
        "common/visibility",
        "controls/data/grid"
    ],

    function (selectHelper, visibility, gridModule) {

        function initialize(
            jsSelectors,
            codeValues,
            payOptionMethodDictionary,
            supplementalPayOptionMethodDictionary) {

            // initialize js selectors
            var benefitModificationForm = $.js(jsSelectors.benefitModificationForm);
            var masterBeneficiariesContainer = benefitModificationForm.js(jsSelectors.masterBeneficiariesContainer, { required: false });
            var singleBeneficiaryContainer = benefitModificationForm.js(jsSelectors.singleBeneficiaryContainer, { required: false });
            var multiBeneficiariesContainer = benefitModificationForm.js(jsSelectors.multiBeneficiariesContainer, { required: false });
            var paymentOptionSelect = benefitModificationForm.js(jsSelectors.paymentOptionSelect, { required: false });
            var suppPaymentOptionSelect = benefitModificationForm.js(jsSelectors.suppPaymentOptionSelect, { required: false });

            // initialize select helpers
            var paymentOptionSelectHelper = selectHelper.getHelper(paymentOptionSelect);
            var suppPaymentOptionSelectHelper = selectHelper.getHelper(suppPaymentOptionSelect);

            // Register payment option change handler
            paymentOptionSelect.change(payOptionChanged);
            suppPaymentOptionSelect.change(payOptionChanged);

            // Show/hide beneficiary grid based on selected payment option
            function payOptionChanged() {
                var paymentOptionKey = paymentOptionSelect.val();
                var suppPaymentOptionKey = suppPaymentOptionSelect.val();

                var paymentMethod = payOptionMethodDictionary[paymentOptionKey];
                var supplementalPaymentMethod = supplementalPayOptionMethodDictionary[suppPaymentOptionKey];

                // If both are null, hide beneficiary selection
                if (paymentMethod == null && supplementalPaymentMethod == null) {
                    visibility.hide(masterBeneficiariesContainer);
                    return;
                }

                // Show beneficiaries if either is not Single Life
                var shouldDisplayBeneficiaries =
                    paymentMethod !== codeValues.singleLife ||
                    (supplementalPaymentMethod != null && supplementalPaymentMethod !== codeValues.singleLife);

                if (!shouldDisplayBeneficiaries) {
                    visibility.hide(masterBeneficiariesContainer);
                    return;
                }

                visibility.show(masterBeneficiariesContainer);

                // Allow multi-select ONLY if Either is Certain & Life
                var allowMultiSelect =
                    paymentMethod === codeValues.certainAndLife ||
                    (supplementalPaymentMethod != null && supplementalPaymentMethod === codeValues.certainAndLife);

                if (allowMultiSelect) {
                    visibility.hide(singleBeneficiaryContainer);
                    visibility.show(multiBeneficiariesContainer);
                } else {
                    visibility.show(singleBeneficiaryContainer);
                    visibility.hide(multiBeneficiariesContainer);
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);